// Billing retains existing tier IDs; the public paid offer is Unlimited.
export type PublicPlanTier = 'student' | 'power';
export type BillingPeriod = 'monthly' | 'annual';

export const PRICING = {
  freeMonthlyGenerations: 3,
  freeCardsPerGeneration: 50,
  unlimitedMonthly: 15,
  unlimitedAnnual: 149,
};

export const PRICING_COPY = {
  freeAllowance: `${PRICING.freeMonthlyGenerations} free generations per month, up to ${PRICING.freeCardsPerGeneration} cards each`,
  freeCardLimit: `Up to ${PRICING.freeCardsPerGeneration} cards per generation`,
  unlimitedPrice: `$${PRICING.unlimitedMonthly}/month or $${PRICING.unlimitedAnnual}/year`,
};

export function planLabel(tier: string): string {
  return tier === 'free' ? 'Free' : 'Unlimited';
}

export interface PublicPlan {
  tier: 'free' | PublicPlanTier;
  name: string;
  monthlyPrice: number;
  annualPrice: number | null;
  description: string;
  features: string[];
  popular?: boolean;
}

export const PUBLIC_PLANS: PublicPlan[] = [
  {
    tier: 'free', name: 'Free', monthlyPrice: 0, annualPrice: null,
    description: 'Try the full review workflow on real lectures.',
    features: [`${PRICING.freeMonthlyGenerations} generations / month`,
      `Up to ${PRICING.freeCardsPerGeneration} cards per generation`,
      'Cloze, Q&A, and image occlusion',
      'Source-backed review and coverage', 'Export to Anki (.apkg)', 'Unlimited cloud library',
      'Concise coverage'],
  },
  {
    tier: 'student', name: 'Unlimited', monthlyPrice: PRICING.unlimitedMonthly, annualPrice: PRICING.unlimitedAnnual,
    description: 'Built for your lecture schedule.',
    features: ['Unlimited generation', 'Every card traceable to the slide it came from',
      'Review queue that learns from your keeps and rejects',
      'Cloze, Q&A, and image occlusion', 'All coverage depths',
      'Named Library folders', 'Unlimited cloud library',
      'Original lecture file storage', 'Priority generation queue'],
    popular: true,
  },
];

export function monthlyEquivalent(plan: PublicPlan): number {
  return plan.annualPrice === null ? plan.monthlyPrice : plan.annualPrice / 12;
}

export function isPublicPaidTier(tier: string): tier is PublicPlanTier {
  return tier === 'student';
}
